import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import environment from '@/environments/environment.dev'

import rootSaga from './sagas'
import rootReducer from './slices'
import { apiSlice } from './slices/apiSlice'

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: rootReducer,
  devTools: environment.enableReduxDevTool,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.navigate'],
      },
    }).concat(sagaMiddleware, apiSlice.middleware)
  },
})

sagaMiddleware.run(rootSaga)

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export default store
